   import React, { useState } from "react";


const Sidebar = () => {
 
return (

        <div>
            <div class="site-sidebar scrollbar-enabled clearfix">
               
                <div class="side-user">
                    <a class="col-sm-12 media clearfix" href="#">
                        
                        <div class="media-body hide-menu">
                            <h4 class="media-heading mr-b-5 text-uppercase">Admin Panel</h4> 
                        </div>
                    </a>
                    <div class="clearfix"></div>
                   
                </div>
               
           
                <nav id="sidebar" class="bg-dark">
                    
                    <ul class="list-unstyled components sidebar-menu">

                   
                    <li class="active">
                        <a href="/dashboard" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Dashboard
                        </a>
                    </li>
                     <li>
                        <a href="#banner" class="dropdown-toggle sidebar-link" data-bs-toggle="collapse">
                        <i class="bi bi-menu-button-wide-fill"></i> Manage Banner
                        </a>
                        <ul class="collapse list-unstyled ms-4" id="banner">
                        <li><a href="/WebBanner" class="sidebar-sublink">Add Banner</a></li>
                         
                        </ul>
                    </li>
                   
                    <li>
                        <a href="#submenu1" class="dropdown-toggle sidebar-link" data-bs-toggle="collapse">
                        <i class="bi bi-menu-button-wide-fill"></i> Manage Rooms
                        </a>
                        <ul class="collapse list-unstyled ms-4" id="submenu1">
                        <li><a href="/RoomCategory" class="sidebar-sublink">Add Rooms</a></li>
                         <li><a href="/RoomAmenities" class="sidebar-sublink">Room Amenities</a></li>
                          <li><a href="/room-details" class="sidebar-sublink">Room Details</a></li>
                           <li><a href="/RoomGallery" class="sidebar-sublink">Room Gallery</a></li>
                           <li><a href="/RoomInventory" class="sidebar-sublink">Room Inventory</a></li>
                       
                        </ul>
                    </li>

                     <li>
                        <a href="/AddGallery" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Gallery
                        </a>
                    </li>

                     <li>
                        <a href="/PendingsBooking" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Pending Booking
                        </a>
                    </li>
                     <li>
                        <a href="/ConfirmBooking" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Confirm Booking
                        </a>
                    </li>
                     <li>
                        <a href="/QuickEnquiry" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Quick Enquiry
                        </a>
                    </li>
                     <li>
                        <a href="/ContactEnquiry" class="sidebar-link">
                        <i class="bi bi-speedometer2"></i> Contact Enquiry
                        </a>
                    </li>
                    <li>
                        <a href="#submenu3" class="dropdown-toggle sidebar-link" data-bs-toggle="collapse">
                        <i class="bi bi-gear"></i> Settings
                        </a>
                        <ul class="collapse list-unstyled ms-4" id="submenu3">
                        <li><a href="/ChangePassword" class="sidebar-sublink">Change Password</a></li>
                        <li><a href="/Feedbacks" class="sidebar-sublink">Feedbacks</a></li>
                        <li><a href="/Gcategory" class="sidebar-sublink">Gallery Category</a></li>
                        </ul>
                    </li>

                    </ul>
                </nav>
                
            </div>

            </div>
  );
};

export default Sidebar;